import { ActionCard, ActionCardWrap, IActionCard, TitlePageH1 } from '@tap/mui-ui';
import { AppBasePath } from '../../env';
import DefectsIcon from './icons/DefectsIcon';

/*
*   Входные данные
*/

const INPUTDATA = `${AppBasePath}/input-data`;

export const InputDataCards: IActionCard[] = [
    {
        title: 'Дефекты',
        description: 'Список типов и видов дефектов для заявок по контролю качества.',
        img: <DefectsIcon />,
        link: INPUTDATA + '/defects',
    },
];

export function InputDataPage() {

    return (
        <>
            <TitlePageH1>Входные данные</TitlePageH1>
            <ActionCardWrap>
                {InputDataCards.map((card: IActionCard) => (
                    <ActionCard
                        key={card.title}
                        {...card}
                    />
                ))}
            </ActionCardWrap>
        </>
    );
}
